<template>
  <div>
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :has-form="true"
      title="搜索"
      top="10%"
      class="search-dialog"
      width="33%"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >
      <gs-form
        ref="form"
        class="form"
        label-width="110px"
        label-position="left"
        gap="small"
      >
        <gs-form-item
          label="搜索设备或对象"
          prop="name"
          class="form-item-name"
        >
          <gs-input
            ref="nameInput"
            v-model="name"
            type="text"
          />
        </gs-form-item>

        <gs-form-item
          label="搜索路径"
          prop="lookIn"
          class="form-item-lookIn"
        >
          <gs-input
            v-model="pathName"
            :disabled="pathObj === null"
            style="width:80%"
          />
          <gs-button @click="addPath">...</gs-button>
        </gs-form-item>
      </gs-form>
    </gs-modal>
    <gs-modal
      v-model="visiblePath"
      :before-close="beforeClosePath"
      class="alarmReceiver-select"
      title="选择路径"
      @close="closePath"
      @confirm="handleConfirmPath"
    >
      <div class="treeList">
        <el-tree
          v-if="visiblePath"
          ref="tree"
          :data="dataList"
          :expand-on-click-node="false"
          :highlight-current="true"
          :props="props"
          :node-key="'id'"
          @node-click="tree_left_click"
        />
      </div>
    </gs-modal>
  </div>
</template>
<script>
import service from '../../service/leftService.js'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      name: '',
      pathId: '',
      pathObj: null,
      props: {
        label: 'name'
      },
      dataList: [],
      visiblePath: false,
      selectNode: null,
      pathName: ''
    }
  },
  computed: {
    ...mapState({
      visible: 'searchDialogShow',
      objectData: 'objectInfo'
    })
  },
  watch: {
    pathObj () {
      this.pathName = this.pathObj ? this.pathObj.fullName : ''
    },
    pathName () {
      if (this.pathObj && this.pathName !== this.pathObj.fullName) {
        this.pathObj = null
      }
    },
    visible () {
      if (this.visible) {
        this.name = ''
        this.pathObj = this.objectData
        this.pathId = this.pathObj.id
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'SEARCH_DIALOG_HIDE'
    }),
    addPath () {
      this.visiblePath = true
      service.getTree().then(res => {
        this.dataList = res
      })
    },
    beforeClosePath () {
      this.visiblePath = false
    },
    closePath () {
      this.visiblePath = false
    },
    handleConfirmPath () {
      this.pathObj = this.selectNode
      this.pathId = this.pathObj.id
      this.visiblePath = false
    },
    handleConfirm () {
      let params = {
        id: this.pathId,
        name: this.name
      }
      service.search(params).then(res => {
        this.$store.state.searchResult = res
        this.$store.state.searchParams = params
        this.close()
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    beforeConfirm (e, done) {
      done()
    },
    beforeClose (e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    },
    tree_left_click (node) {
      this.selectNode = node
    }
  }
}
</script>
<style lang="scss" scoped>
  .search-dialog {
    .form {
      &-item-lookIn {
        &-select {
          width: 90%
        }
      }
      fieldset {
        width:80%;
        padding: 12px;
        border-radius: 5px;
        border: solid 2px #d9d9d9
      }
    }
  }
  .treeList {
      height: 300px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/search/search.vue